module.exports = __webpack_public_path__ + "img/VetoSans-Bold_1.7a220b89.svg";